<input class="vertical-center" *ngIf="isSelected" type="radio" [name]="name" [id]="id" checked disabled />
<input class="vertical-center" *ngIf="!isSelected" type="radio" [name]="name" [id]="id" disabled />
